import { useFrame } from '@react-three/fiber';
import { useEffect } from 'react';

var useController = function useController(controller, renderPriority) {
  useEffect(function () {
    controller.start();
    return function () {
      return controller.stop();
    };
  });
  useFrame(function () {
    controller.update();
  }, renderPriority);
};
var Controller = function Controller(_ref) {
  var controller = _ref.controller,
    updatePriority = _ref.updatePriority;
  useController(controller, updatePriority);
  return null;
};

export { Controller, useController };
